




















































































import { debounce } from 'lodash-es';

import { search } from '@adobe/edex/frontend/api/search';
import { checkObjectArrayDiff, getID } from '@adobe/edex/frontend/views/course/settings/constants';

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    selected: {
      type: Array,
      required: true,
    },
    role: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      show: false,
      showSelected: false,
      filter: '',
      searchResults: [],
      localSelected: [],
      loading: false,
      error: false,
    };
  },
  mounted() {
    this.localSelected = this.selected;
  },
  async created() {
    this.onMemberSearch = debounce(this.onMemberSearch, 300);
  },
  computed: {
    hasFilter() {
      return this.filter !== '';
    },
    hasResults() {
      return Boolean(this.searchResults.length);
    },
    selectedIDs() {
      return this.localSelected.map(getID);
    },
  },
  watch: {
    selected(current, prev) {
      if (
        checkObjectArrayDiff(current, prev) &&
        checkObjectArrayDiff(current, this.localSelected)
      ) {
        this.localSelected = current;
        this.handleHide();
      }
    },
  },
  methods: {
    async onMemberSearch() {
      this.loading = true;

      try {
        const { data } = await search({
          params: {
            r: 'members',
            q: this.filter,
            role: this.role,
          },
        });
        this.searchResults = data.data;
      } catch (error) {
        this.error = true;
      }

      this.loading = false;
    },
    handleHide() {
      this.filter = '';
      this.searchResults = [];
      this.loading = false;
      this.error = false;
      this.show = false;
    },
    handleSelect(member) {
      if (this.selectedIDs.includes(member.id)) {
        this.localSelected = this.localSelected.filter(
          item => item.id !== member.id
        );
      } else {
        this.localSelected = [member, ...this.localSelected];
      }
    },
    handleClose() {
      this.$emit('onMemberChanged', {
        data: this.localSelected,
        name: this.name,
      });
      this.handleHide();
    },
  },
};
